import { render, staticRenderFns } from "./ProofUploadDialog.vue?vue&type=template&id=04f90212"
import script from "./ProofUploadDialog.vue?vue&type=script&lang=js"
export * from "./ProofUploadDialog.vue?vue&type=script&lang=js"
import style0 from "./ProofUploadDialog.vue?vue&type=style&index=0&id=04f90212&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports